import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Element
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Element)
import {post,get} from '@/utils/request'
import './style/style.less'
import './assets/font/font.css'
Vue.prototype.$postAction = post
Vue.prototype.$getAction = get
// 注册全局组件
import TopNav from '@/components/topNav' // 顶部导航
Vue.component('top-nav', TopNav)
import BotNav from '@/components/botNav' // 底部导航
Vue.component('bot-nav', BotNav)

// 注册百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'zLYxKZLFfQRNToIYf3BTCBDcn9tGQxm8'
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
